"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultIconSize = void 0;
exports.defaultIconSize = [40, 40];
//# sourceMappingURL=InputMapTypes.js.map